import React from "react";
import { Row, Col, Typography, Button, Card, Space } from "antd";
import { useNavigate } from "react-router-dom";
import banner from "../assets/banner.png";
import partner from "../assets/partner.png";

const { Title, Paragraph } = Typography;

const PartnerWithUs = () => {
  const navigate = useNavigate();

  const partnerships = [
    {
      title: "Sponsorship",
      description:
        'Fund tournaments or events in exchange for naming rights, banners and shoutouts (e.g., "Sponsored by [Your Brand]").',
    },
    {
      title: "Collaboration",
      description:
        "Co-host activities like dv-ihis workshops or outdoor challenges for special children.",
    },
    {
      title: "Volunteer or In-Kind Support",
      description:
        "Contribute to our community-driven initiatives by providing resources, expertise or helping hands during Bloom Day or local cricket leagues — a meaningful way to support social impact and corporate social responsibility (CSR) efforts.",
    },
    {
      title: "Media / Ambassador Partnerships",
      description:
        "Promote our events through your platforms or become an official ambassador for ongoing visibility.",
    },
  ];

  const steps = [
    {
      number: "1.",
      title: "Review Options:",
      description: "Explore the partnership types above.",
    },
    {
      number: "2.",
      title: "Reach Out:",
      description:
        "Click on Become a partner button, fill the form and we will contact you.",
    },
    {
      number: "3.",
      title: "Discuss & Customize:",
      description: "We'll schedule a call to tailor a package.",
    },
    {
      number: "4.",
      title: "Launch Together:",
      description:
        "Sign the agreement and watch the magic happen at our events.",
    },
  ];

  const handleBecomePartner = () => {
    navigate("/contact-form");
  };

  return (
    <div style={{ width: "100%", backgroundColor: "#fff", overflow: "hidden" }}>
      {/* ===== Top Full-Width Banner ===== */}
      <div style={{ width: "100%", overflow: "hidden" }}>
        <img
          src={banner}
          alt="Sports Banner"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
          }}
        />
      </div>

      {/* ===== Middle Two-Column Section ===== */}
      <div style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
        <Row gutter={[32, 32]} align="middle" justify="center">
          {/* Left Column - Text */}
          <Col xs={24} md={12}>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Title level={3} style={{ color: "#4B0082", marginBottom: 0 }}>
                Partner With Yalla Nellab: Empower Communities Through Sports
                And Inclusivity
              </Title>

              <Paragraph style={{ fontSize: "16px", color: "#555" }}>
                Join us as we host exciting tournaments in football, cricket
                and jiu-jitsu, along with special events dedicated to social
                welfare and community growth. Together, we can create
                unforgettable experiences and build a stronger, more united
                community through sports.
              </Paragraph>

              <Button
                type="primary"
                size="large"
                style={{
                  color:"black",
                  backgroundColor: "white",
                  borderColor: "#7e7e7eff",
                  alignSelf: "flex-start",
                }}
                onClick={handleBecomePartner}
              >
                Become a partner
              </Button>
            </Space>
          </Col>

          {/* Right Column - Image */}
          <Col xs={24} md={12}>
            <Card
              bordered={false}
              cover={
                <img
                  src={partner}
                  alt="Partner Event"
                  style={{
                    width: "100%",
                    borderRadius: "12px",
                    objectFit: "cover",
                  }}
                />
              }
              style={{
                boxShadow: "none",
                background: "transparent",
              }}
            />
          </Col>
        </Row>
      </div>

      {/* ===== Bottom Text Section ===== */}
      <div style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Title level={3} style={{ color: "#000", marginBottom: 0 }}>
            Why Partner With Us?
          </Title>

          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            At <b>Yalla Nellab</b>, we're more than an event organizer — we're a
            catalyst for community growth.
          </Paragraph>

          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            Partnering with us means:
          </Paragraph>

          <ul
            style={{
              paddingLeft: "20px",
              margin: 0,
              listStyleType: "disc",
              color: "#555",
              fontSize: "16px",
              lineHeight: "1.7",
            }}
          >
            <li>
              <b>Brand Visibility</b> – Reach thousands of participants,
              spectators and online followers through event branding, social
              media shoutouts and sponsorship placements.
            </li>
            <li>
              <b>Community Impact</b> – Support inclusive initiatives like Bloom
              Day, helping children with special needs thrive through fun,
              adaptive activities.
            </li>
            <li>
              <b>Networking Opportunities</b> – Connect with like-minded
              organizations, athletes and families in football, cricket, jiu
              jitsu and outdoor adventures.
            </li>
            <li>
              <b>Customized ROI</b> – From logo placements at tournaments to
              co-branded events, we tailor partnerships to meet your goals —
              whether for CSR, marketing or brand promotion.
            </li>
          </ul>
        </Space>
      </div>

      {/* ===== Partnership Types Section ===== */}
      <div style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
        {/* Header Section */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Title level={2} style={{ marginBottom: "8px", fontWeight: 600 }}>
            Types of Partnerships
          </Title>
          <Paragraph style={{ color: "#666", margin: 0 }}>
            We offer flexible partnership models to suit businesses, nonprofits
            and individuals:
          </Paragraph>
        </div>

        {/* Cards Section */}
        <Row gutter={[24, 24]} style={{ marginBottom: "60px" }}>
          {partnerships.map((item, index) => (
            <Col xs={24} sm={24} md={12} lg={12} key={index}>
              <Card
                bordered
                style={{
                  height: "100%",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                }}
                bodyStyle={{ padding: "24px" }}
              >
                <Title
                  level={4}
                  style={{
                    marginBottom: "12px",
                    textAlign: "left",
                    fontWeight: 600,
                  }}
                >
                  {item.title}
                </Title>
                <Paragraph
                  style={{
                    margin: 0,
                    textAlign: "left",
                    color: "#333",
                    lineHeight: "1.6",
                  }}
                >
                  {item.description}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>

        {/* How to Get Involved Section */}
        <div>
          <Title
            level={3}
            style={{ marginBottom: "24px", textAlign: "left", fontWeight: 600 }}
          >
            How To Get Involved
          </Title>

          <Paragraph style={{ textAlign: "left", marginBottom: "24px" }}>
            Ready to partner? It's simple:
          </Paragraph>

          <div style={{ textAlign: "left" }}>
            {steps.map((step, index) => (
              <div key={index} style={{ marginBottom: "16px" }}>
                <span
                  style={{
                    fontWeight: 600,
                    marginRight: "8px",
                    color: "#4B0082",
                  }}
                >
                  {step.number}
                </span>
                <span style={{ fontWeight: 600, marginRight: "8px" }}>
                  {step.title}
                </span>
                <span style={{ color: "#333" }}>{step.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerWithUs;